import React from "react";
import styled from "styled-components";
import settings from "@src/settings";
import trimLeading from "@src/utils/trimLeading";
import SectionTitle from "../SectionTitle";
import { up, only, down } from "styled-breakpoints";
import getGridWidth from "@src/utils/getGridWidth";
import getGridHeight from "@src/utils/getGridHeight";

export const Frame = styled.footer<{ windowW: number | null }>`
	display: flex;
	background-color: ${settings.color.darken};
	color: #fff;
	& > ${SectionTitle} {
		flex: 0 0 calc(4 * 5rem + (4 - 1) * 1rem);
	}
	${up("xxl")} {
		padding: 0 calc((100% - ${settings.contentWidth.xxl}px) / 2);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3, withTopGap: true })}px;
	}
	${only("xl")} {
		padding: 0 calc((100% - ${settings.contentWidth.xl}px) / 2);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3 })}px;
	}
	${only("lg")} {
		padding: 0 calc((100% - ${settings.contentWidth.lg}px) / 2);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3, withTopGap: true })}px;
	}
	${only("md")} {
		padding: 0 calc((100% - ${settings.contentWidth.md}px) / 2);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3, withTopGap: true })}px;
	}
	${only("sm")} {
		padding: 0 calc((100% - ${settings.contentWidth.sm}px) / 2);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3, withTopGap: true })}px;
	}
	${down("md")} {
		flex-direction: column;
		& > ${SectionTitle} {
			flex: 0 0 auto;
		}
	}
	${down("xs")} {
		padding: 0
			calc(
				(
						100% -
							${(props) =>
								getGridWidth({ windowW: props.windowW }) -
								settings.baseGrid.fontSize * 4}px
					) / 2
			);
		padding-top: ${getGridHeight({
			rows: 2,
			withTopGap: true,
			withBottomGap: true,
		})}px;
		padding-bottom: ${getGridHeight({ rows: 3, withTopGap: true })}px;
	}
`;
export const TextFrame = styled.div`
	flex: 1 1 auto;
	* + & {
		margin-left: 1rem;
	}
	${down("md")} {
		* + & {
			margin-left: 0;
		}
	}
	${only("md")} {
		* + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withBottomGap: true,
				withTopGap: true,
			})}px;
		}
	}
	${only("sm")} {
		* + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withBottomGap: true,
				withTopGap: true,
			})}px;
		}
	}
	${down("xs")} {
		* + & {
			margin-top: 2.2rem;
		}
	}
`;
export const Lead = styled.p`
	font-weight: 500;
	font-style: normal;
	font-family: ${settings.font.jp};
	letter-spacing: 2.2857px;
	text-align: justify;
	${trimLeading({ fontSize: 16, lineHeight: 37 })}
`;
export const Tel = styled.dl`
	display: flex;
	align-items: center;
	& > dt {
		font-weight: 700;
		font-style: normal;
		font-family: "Montserrat", serif;
		color: #ffffff;
		font-size: 18.2857px;
		letter-spacing: 2.05px;
		line-height: 1;
		margin-right: 1rem;
	}
	& > dd {
		font-weight: 400;
		font-family: ${settings.font.en};
		font-size: 32px;
		letter-spacing: 5px;
		line-height: 100%;
		${trimLeading({ fontSize: 32, lineHeight: 32, font: "montserrat" })}
	}
	${up("xl")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
			}) + 17}px;
		}
	}
	${only("lg")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
			}) + 15}px;
		}
	}
	${only("md")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
				withBottomGap: true,
			}) + 5}px;
		}
	}
	${only("sm")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 2,
			}) + 8}px;
		}
	}
	${down("xs")} {
		${Lead} + & {
			margin-top: ${getGridHeight({
				rows: 1,
				withTopGap: true,
				withBottomGap: true,
			})}px;
		}
		display: block;
		& > dt {
			margin-right: 0;
			margin-bottom: 1rem;
		}
	}
`;
export const Note = styled.p`
	font-weight: 400;
	font-family: ${settings.font.jp};
	font-size: 14.2222px;
	letter-spacing: 1.96px;
	line-height: 100%;
	${trimLeading({ fontSize: 14.2222, lineHeight: 14.2222 })}
	${Tel} + & {
		margin-top: 1rem;
	}
`;
